const promoId = {
	promo: {
		title: "Sistem Diskon",
		subtitle: "Kelola promo & reward pelanggan",
		discount_system_status: "Status Sistem Diskon:",
		status_active: "Aktif",
		status_inactive: "Nonaktif",
		create_button: "Buat Promo",
		table: {
			title: "Data Promo",
			empty_state: {
				title: "Tidak ada data promo",
				description: "Silakan tambahkan promo baru.",
			},
			columns: {
				date: "Tanggal",
				created_by: "Dibuat Oleh",
				ref_id: "Ref ID",
				name: "Nama",
				type: "Tipe Reward",
				reward_amount: "Nominal Reward",
				max_amount: "Maks Nominal",
				expired_at: "Tanggal Kadaluarsa",
				status: "Status",
				action: "Action",
			},
			types: {
				discount: "Potongan Transaksi",
				free_product: "Gratis Produk",
				discount_per_product: "Potongan Per Produk",
				cashback: "Cashback",
				loyalty: "Loyalty",
			},
			status: {
				active: "Aktif",
				inactive: "Tidak Aktif",
			},
			detail: "Detail",
		},
		cards: {
			transaction: {
				title: "Potongan Transaksi",
				description:
					"Pelanggan mendapatkan potongan harga dari pembelian produk dengan persyaratan tertentu.",
				example:
					"Contoh: Belanja Rp 100.000 dapat potongan transaksi 10% senilai Rp 10.000",
			},
			free_product: {
				title: "Gratis Produk",
				description:
					"Pelanggan mendapatkan produk barang gratis jika membeli barang tertentu dan dengan persyaratan tertentu.",
				example: "Contoh: Beli Nasi Goreng 1 Gratis Es Jeruk",
			},
			per_product: {
				title: "Potongan Harga Per Produk",
				description:
					"Pelanggan mendapatkan potongan harga dari pembelian produk tertentu dengan persyaratan tertentu.",
				example:
					"Contoh: Belanja produk A dengan harga Rp 10.000 sebanyak 2 qty dapat potongan harga 10% senilai Rp 1000 untuk produk A",
			},
		},
		modal: {
			title: "Tambah Promo",
			fields: {
				name: "Nama Promo",
				name_placeholder: "Nama Promo",
				all_stores: "Berlaku di Semua Toko?",
				period_enabled: "Periode Tertentu?",
				period_start: "Tanggal Mulai",
				period_end: "Tanggal Selesai",
				min_transaction_enabled: "Minimal Transaksi?",
				min_transaction_amount: "Nominal Minimal Transaksi",
				min_transaction_placeholder: "Nominal Minimal",
				day_enabled: "Berlaku Hari Tertentu?",
				time_enabled: "Berlaku Jam Tertentu?",
				product_enabled: "Berlaku Produk Tertentu?",
				payment_method_enabled: "Berlaku Metode Pembayaran Tertentu?",
				reward_type: "Jenis Potongan",
				reward_type_placeholder: "Pilih Jenis Potongan",
				reward_type_fix: "Fix Nominal",
				reward_type_percent: "Persentase",
				nominal: "Nominal Potongan",
				nominal_placeholder: "Nominal Potongan",
				max_nominal: "Maksimal Nominal Reward",
				max_nominal_placeholder: "Maksimal Nominal Reward",
				expired: "Tanggal Kadaluarsa",
				status: "Status",
				status_placeholder: "Pilih Status",
				status_active: "Active",
				status_inactive: "Inactive",
			},
			cancel: "Batal",
			save: "Simpan",
		},
	},
};

export default promoId;
